// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.z_YvFX1OuCMZ6AGiEuB9{flex-direction:column;gap:24px;width:100%;max-width:778px;height:100%;padding-right:6px;display:flex}.RH_N16eHOu0HqhqhAvMe{grid-template-columns:repeat(3,1fr);gap:12px;display:grid}.S4GneBwcfwb9MkWxS1Vs{gap:12px;padding:32px}.MpYWG2S8ilk16K6pk_En{flex-grow:1;grid-template-columns:auto 1fr auto}.MpYWG2S8ilk16K6pk_En+div{margin-left:8px}.pLVOz6PxW_E4r5yO7yjE>div:first-of-type{flex:1;grid-template-columns:auto 1fr auto;display:grid}.F5rYxPO1QeArnPWuRBbI{max-height:49px;overflow:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `z_YvFX1OuCMZ6AGiEuB9`,
	"cardsContainer": `RH_N16eHOu0HqhqhAvMe`,
	"choiceTile": `S4GneBwcfwb9MkWxS1Vs`,
	"selectOptionWrap": `MpYWG2S8ilk16K6pk_En`,
	"selectOptionWrapRoundRobin": `pLVOz6PxW_E4r5yO7yjE`,
	"multiSelectPlaceholder": `F5rYxPO1QeArnPWuRBbI`
};
export default ___CSS_LOADER_EXPORT___;
